import { logger } from "@utils/logger"

export const DEFAULT_CALENDAR_AVAILABILITY_NAME = 'HachiMind Disponibilidad'
export const DEFAULT_CALENDAR_APPOINTMENTS_NAME = 'HachiMind'
export const APP_NAME = 'HachiMind'
export const RESOURCE_NAME = 'event'

export const APPOINTMENT_TIME_MINUTES = 30

export enum EventCode {
    EMERGENCY_CALL = 'emergency_call',
    APPOINTMENT = 'appointment',
    AVAILABILITY = 'availability'
}
export type EventScheme = {
    code: EventCode,
    params?: Record<string, any>
}

export function getMetadataParams(q: Record<string, any>) {
    return Object.entries(q).map(([k, v]) => `${k}:${v}`).join(',')
}

export function getMetadataString(props: EventScheme) {
    return Object.values({
        app: APP_NAME.toLowerCase(),
        resource: RESOURCE_NAME,
        code: props.code,
        ...(props.params && { params: getMetadataParams(props.params) }),
    }).join(":")
}

export function searchMetadataString(q: Partial<EventScheme>) {
    const strQ = Object.values({
        app: APP_NAME.toLowerCase(),
        resource: RESOURCE_NAME,
        ...(q.code && { code: q.code }),
        ...(q.params && { params: getMetadataParams(q.params) }),
    }).join(":")
    // logger.debug(strQ)
    return strQ
}


export function getEventCodeType(str: string) {
    for (const code of Object.values(EventCode)) {

        if (str.includes(searchMetadataString({ code }))) {
            return code
        }
    }
}
